import React from 'react';

import Allowed from 'components/shared/Permissions/Allowed';

const AllowedSection = ({ isAdminContext = false, children, ...allowedProps }) =>
  isAdminContext ? <>{children}</> : <Allowed {...allowedProps}>{children}</Allowed>;

export default AllowedSection;
